// URL pattern regex
const urlPattern = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.[a-zA-Z]{2,}[^\s]*)/gi;

/**
 * Validates if text contains links/URLs
 * @param text - Text to validate
 * @returns Object with isValid flag and error message
 */
export const validateNoLinks = (text: string): { isValid: boolean; error?: string } => {
  if (!text || text.trim().length === 0) {
    return { isValid: true };
  }

  const hasLinks = urlPattern.test(text);
  if (hasLinks) {
    return {
      isValid: false,
      error: 'Notes field cannot contain links or URLs. Please remove all links.',
    };
  }

  return { isValid: true };
};

/**
 * Checks if text contains links (for warning purposes)
 * @param text - Text to check
 * @returns true if links are found
 */
export const containsLinks = (text: string): boolean => {
  if (!text || text.trim().length === 0) {
    return false;
  }
  return urlPattern.test(text);
};




